import { LabelValue } from "@app/types";

export const StatisticsChartType = Object.freeze({
  VIEW_COUNT: "viewCount",
  LISTEN_COUNT: "listenCount",
  LISTEN_TIME: "totalTime",
});

export const StatisticsChartTypeText = Object.freeze({
  [StatisticsChartType.VIEW_COUNT]: "Số lượt xem",
  [StatisticsChartType.LISTEN_COUNT]: "Số lượt nghe",
  [StatisticsChartType.LISTEN_TIME]: "Thời gian nghe",
});

export const StatisticsType: readonly LabelValue[] = Object.freeze([
  {
    label: StatisticsChartTypeText[StatisticsChartType.VIEW_COUNT],
    value: StatisticsChartType.VIEW_COUNT,
  },
  {
    label: StatisticsChartTypeText[StatisticsChartType.LISTEN_COUNT],
    value: StatisticsChartType.LISTEN_COUNT,
  },
  {
    label: StatisticsChartTypeText[StatisticsChartType.LISTEN_TIME],
    value: StatisticsChartType.LISTEN_TIME,
  },
]);
